import { makeStyles } from "@mui/styles";

export const useLoadingFrameStyles = makeStyles(() => ({
    hidden: {
        display: "none",
    },
    message: {
        fontSize: "0.875rem",
        lineHeight: "1.57",
        letterSpacing: "0.00714em",
    },
    error: {
        marginTop: "30px",
    },
}));
